var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5859 0H2.92969C1.31152 0 0 1.31152 0 2.92969V40.5859C0 42.2043 1.31152 43.5156 2.92969 43.5156H18.8277V68.8285C18.8277 70.4461 20.1393 71.7582 21.7574 71.7582H31.1723C31.7871 71.7582 32.3863 71.5647 32.885 71.2051C33.3837 70.8456 33.7565 70.3382 33.9508 69.7549L43.3648 41.5123C43.4646 41.2141 43.5158 40.9012 43.5158 40.5861V2.92969C43.5158 1.31152 42.2041 0 40.5859 0ZM97.0703 0H59.4141C57.7957 0 56.4844 1.31152 56.4844 2.92969V40.5859C56.4844 42.2043 57.7957 43.5156 59.4141 43.5156H75.3129V68.8285C75.3129 70.4461 76.6242 71.7582 78.2426 71.7582H87.6562C88.2711 71.7581 88.8704 71.5646 89.3692 71.2051C89.868 70.8455 90.2411 70.3382 90.4355 69.7549L99.8496 41.5123C99.9486 41.2141 99.9998 40.9012 99.9998 40.5861V2.92969C99.9998 1.31152 98.6883 0 97.0701 0H97.0703Z",
    fill: "url(#paint0_linear_1993_25748)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1993_25748",
    x1: 65.1311,
    y1: 0.00000316081,
    x2: 50.5753,
    y2: 72.7771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5514"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.763ab1f49d08f6856947629a983eb1b2.svg";
export { ForwardRef as ReactComponent };